var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6v14c0 1.1-.9 2-2 2H5a2 2 0 01-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14z",
    fill: "#036"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDZWMjBDMjEgMjEuMSAyMC4xIDIyIDE5IDIySDVDMy44OSAyMiAzIDIxLjEgMyAyMEwzLjAxIDZDMy4wMSA0LjkgMy44OSA0IDUgNEg2VjJIOFY0SDE2VjJIMThWNEgxOUMyMC4xIDQgMjEgNC45IDIxIDZaTTUgOEgxOVY2SDVWOFpNMTkgMjBWMTBINVYyMEgxOVoiIGZpbGw9IiMwMDMzNjYiLz4KPC9zdmc+Cg==";
export { SvgCalendar as ReactComponent };